<script setup lang="ts"></script>
<template>
  <article class="flex items-center gap-1.5">
    <div class="relative">
      <div
        class="absolute -right-5 -top-1.5 hidden h-5 w-5 animate-pulse rounded-full bg-gray-300 sm:block"
      />
      <div
        class="absolute -bottom-1.5 -right-7 hidden h-5 w-5 animate-pulse rounded-full bg-gray-300 sm:block"
      />
    </div>
    <div class="h-4 w-14 animate-pulse bg-gray-300 sm:ml-8" />
  </article>
</template>
